import { Component } from '@angular/core';
import { ReservedFirearmsComponent } from 'src/app/reserved-firearms/reserved-firearms.component';
import { Reserved4473Component } from 'src/app/reserved-4473/reserved-4473.component';
import { DriversLicenseSelectionComponent } from 'src/app/shared/modals/drivers-license-selection/drivers-license-selection.component';
import { Seller4473Component } from 'src/app/form-4473/seller-4473/seller-4473.component';

@Component({
    selector: 'app-dispo-build',
    templateUrl: './dispo-build.component.html',
    styleUrl: './dispo-build.component.scss',
    standalone: true,
    imports: [ReservedFirearmsComponent, Reserved4473Component, DriversLicenseSelectionComponent, Seller4473Component],
})
export class DispoBuildComponent {
selected_component: string
}
